/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'animate.css/animate.min.css';

import React from 'react';
import CSSModules from 'react-css-modules';
import every from 'lodash/every';
import has from 'lodash/has';
import isNil from 'lodash/isNil';
import { injectIntl } from 'react-intl';
import {
  Panel,
  Button,
} from 'react-bootstrap';
import ShowIf from 'loracoms/ShowIf';
import Editable from 'loracoms/Editable';
import Nvl from 'loracoms/Nvl';
import Copy from 'loracoms/Copy';
import ErrorSet from 'lorautils/errors/ErrorSet';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';


const defaultProps = {
  readOnly: false,
  show: {},
  status: 'absent',
  errors: new ErrorSet(),
  onSubmit: () => {},
  onChange: () => {},
  onCancel: () => {},
  onEdit: () => {},
  children: null,
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  title: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.object,
  ]).isRequired,
  properties: React.PropTypes.array.isRequired,
  data: React.PropTypes.object.isRequired,
  status: React.PropTypes.string.isRequired,
  show: React.PropTypes.object.isRequired,
  readOnly: React.PropTypes.bool.isRequired,
  errors: React.PropTypes.object,
  onSubmit: React.PropTypes.func,
  onChange: React.PropTypes.func,
  onCancel: React.PropTypes.func,
  onEdit: React.PropTypes.func,
  children: React.PropTypes.node,
};

class PropsPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      status: props.status,
      show: props.show,
      errors: props.errors,
      properties: props.properties,
      dirtyIds: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleEnableEdit = this.handleEnableEdit.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'lora.coms.propspanel');
  }

  componentWillReceiveProps(nextProps) {
    const { data, show, properties, errors, status } = nextProps;
    if (data !== this.props.data) {
      this.setState({ data });
    }
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (properties !== this.props.properties) {
      this.setState({ properties });
    }
    if (errors !== this.props.errors) {
      this.setState({ errors });
    }
    if (status !== this.props.status) {
      this.setState({ status });
    }
  }

  editIds() {
    const { properties } = this.state;
    return properties.filter(p => !p.readOnly).map(p => p.id);
  }

  shouldShowEdit() {
    const { readOnly } = this.props;
    const { properties } = this.state;
    if (readOnly) {
      return false;
    }
    if (every(properties, p => p.readOnly)) {
      return false;
    }
    return true;
  }

  handleChange(editData, id) {
    let { dirtyIds } = this.state;
    dirtyIds = [...dirtyIds, id];
    this.setState({ editData, dirtyIds });
    const { onChange } = this.props;
    if (onChange) {
      onChange(editData, id);
    }
  }

  handleSubmit() {
    this.submitted = true;
    const { onSubmit } = this.props;
    const { editData, dirtyIds } = this.state;
    const success = onSubmit(editData, dirtyIds, this.editIds());
    this.setState({ edit: !success });
    this.submitted = !success;
  }

  handleCancel() {
    this.submitted = false;
    this.setState({ edit: false });
    const { onCancel } = this.props;
    if (onCancel) {
      onCancel(this.editIds());
    }
  }

  handleEnableEdit() {
    const { data } = this.state;
    this.setState({
      edit: true,
      editData: { ...data },
      dirtyIds: [],
    });
    const { onEdit } = this.props;
    onEdit();
  }

  render() {
    const {
      edit = false,
      show,
      data,
      editData = {},
      errors,
      status,
    } = this.state;
    const shouldShow = (p) => {
      let showFlags;
      if (edit) {
        showFlags = show.edit;
      } else {
        showFlags = show.display;
      }
      return !has(showFlags, p.id) || showFlags[p.id];
    };

    let { properties } = this.state;
    properties = properties.filter(shouldShow);

    const propNodes = properties.map((prop) => {
      const {
        id,
        name,
        unit,
        control,
        readOnly = false,
        copy = false,
        formatter = x => <Nvl val={x} nul="empty" status={status} />,
      } = prop;

      let clipboard = null;
      if (copy) {
        const clipVal = copy(data[id]);
        clipboard = <Copy id={`copy-${id}`} text={String(clipVal)} />;
      }

      let error;
      if (this.submitted && errors) {
        error = errors.getArg(id, 'message');
      }

      return (
        <li key={id}>
          <span styleName="pname">{name}</span>
          <span styleName={`pval ${error ? 'error' : ''}`}>
            <Editable
              id={id}
              value={data[id]}
              edit={edit && !readOnly}
              data={editData}
              control={control}
              onChange={ed => this.handleChange(ed, id)}
              formatter={formatter}
              error={error}
            />
            <ShowIf if={!isNil(unit)}>
              <span>{' '}<span styleName="punit">{unit}</span></span>
            </ShowIf>
            <ShowIf if={!edit}>
              <span>{' '}{clipboard}</span>
            </ShowIf>
          </span>
        </li>
      );
    });

    const { title } = this.props;
    const header = (
      <div>
        <span>{title}</span>
        <ShowIf if={this.shouldShowEdit()}>
          <ul className="icontools">
            <li>
              <Button
                bsStyle="aisz-link"
                className="icon"
                onClick={this.handleEnableEdit}
                disabled={edit || status === 'pending'}
              >
                <span className="glyphicons glyphicons-pencil" />
              </Button>
            </li>
          </ul>
        </ShowIf>
      </div>
    );

    return (
      <Panel bsStyle="aisz-white" header={header}>
        <ul styleName="plist">
          {propNodes}
        </ul>
        <ShowIf if={edit}>
          <div className="pull-right">
            <Button bsStyle="aisz-link" onClick={this.handleCancel}>
              <span styleName="cancelBtn">
                <span className="glyphicons glyphicons-remove" />
              </span>
            </Button>
            <Button bsStyle="aisz-link" onClick={this.handleSubmit}>
              <span styleName="submitBtn">
                <span className="glyphicons glyphicons-ok" />
              </span>
            </Button>
          </div>
        </ShowIf>
        <div className="clearfix" />
        {this.props.children}
      </Panel>
    );
  }
}

PropsPanel.defaultProps = defaultProps;
PropsPanel.propTypes = propTypes;

export default injectIntl(CSSModules(PropsPanel, styles, { allowMultiple: true }));




// WEBPACK FOOTER //
// ./src/components/PropsPanel/index.jsx